import { Question } from '../types/setup';

export const questionBank: Question[] = [
  // Course Organization and Planning
  {
    id: 'org_1',
    categoryId: 'organization',
    text: 'Were the course objectives clearly communicated at the beginning of the quarter?',
    type: 'likert'
  },
  {
    id: 'org_2',
    categoryId: 'organization',
    text: 'Did the sequence of topics and assignments support your learning effectively?',
    type: 'likert'
  },
  {
    id: 'org_3',
    categoryId: 'organization',
    text: 'How useful were the course materials in helping you understand the content?',
    type: 'likert'
  },
  {
    id: 'org_4',
    categoryId: 'organization',
    text: 'What aspects of the course structure helped you learn best?',
    type: 'open-ended'
  },
  {
    id: 'org_5',
    categoryId: 'organization',
    text: 'What specific changes could improve the course organization?',
    type: 'open-ended'
  },

  // Clarity and Communication
  {
    id: 'clarity_1',
    categoryId: 'clarity',
    text: 'How effectively did the instructor present complex ideas in a clear and understandable way?',
    type: 'likert'
  },
  {
    id: 'clarity_2',
    categoryId: 'clarity',
    text: 'Did the instructor use real-world examples or practical applications to explain concepts?',
    type: 'likert'
  },
  {
    id: 'clarity_3',
    categoryId: 'clarity',
    text: 'Was the instructor\'s pace of teaching appropriate for the material covered?',
    type: 'likert'
  },
  {
    id: 'clarity_4',
    categoryId: 'clarity',
    text: 'How well did the instructor encourage student participation and engagement in discussions?',
    type: 'likert'
  },
  {
    id: 'clarity_5',
    categoryId: 'clarity',
    text: 'What strategies used by the instructor helped clarify difficult concepts?',
    type: 'open-ended'
  },

  // Teacher-Student Interaction
  {
    id: 'interaction_1',
    categoryId: 'interaction',
    text: 'How approachable and available was the instructor for questions and support outside of class?',
    type: 'likert'
  },
  {
    id: 'interaction_2',
    categoryId: 'interaction',
    text: 'How well did the instructor create an inclusive and respectful learning environment?',
    type: 'likert'
  },
  {
    id: 'interaction_3',
    categoryId: 'interaction',
    text: 'Did you feel encouraged to ask questions and express your ideas during class?',
    type: 'likert'
  },
  {
    id: 'interaction_4',
    categoryId: 'interaction',
    text: 'What specific actions by the instructor made you feel supported in your learning?',
    type: 'open-ended'
  },
  {
    id: 'interaction_5',
    categoryId: 'interaction',
    text: 'What could the instructor do to improve student engagement and interaction?',
    type: 'open-ended'
  },

  // Course Difficulty and Workload
  {
    id: 'difficulty_1',
    categoryId: 'difficulty',
    text: 'How does the current workload compare to your expectations?',
    type: 'likert'
  },
  {
    id: 'difficulty_2',
    categoryId: 'difficulty',
    text: 'How challenging was the course material compared to other courses you\'ve taken?',
    type: 'likert'
  },
  {
    id: 'difficulty_3',
    categoryId: 'difficulty',
    text: 'What aspects of the workload were most manageable or most difficult?',
    type: 'open-ended'
  },
  {
    id: 'difficulty_4',
    categoryId: 'difficulty',
    text: 'What specific adjustments to the workload or assignments would improve your learning experience?',
    type: 'open-ended'
  },

  // Grading and Examinations
  {
    id: 'grading_1',
    categoryId: 'grading',
    text: 'Were the grading criteria clearly communicated?',
    type: 'likert'
  },
  {
    id: 'grading_2',
    categoryId: 'grading',
    text: 'How fair and transparent was the grading process?',
    type: 'likert'
  },
  {
    id: 'grading_3',
    categoryId: 'grading',
    text: 'Did graded assignments and exams reflect the key concepts emphasized in class?',
    type: 'likert'
  },
  {
    id: 'grading_4',
    categoryId: 'grading',
    text: 'How helpful was the feedback on assignments and exams in improving your understanding?',
    type: 'likert'
  },
  {
    id: 'grading_5',
    categoryId: 'grading',
    text: 'What suggestions do you have for improving the grading, assessment, or feedback process?',
    type: 'open-ended'
  },

  // Student Self-Rated Learning
  {
    id: 'learning_1',
    categoryId: 'learning',
    text: 'How much has this course increased your understanding of the subject?',
    type: 'likert'
  },
  {
    id: 'learning_2',
    categoryId: 'learning',
    text: 'How much has this course increased your interest in the subject?',
    type: 'likert'
  },
  {
    id: 'learning_3',
    categoryId: 'learning',
    text: 'What is one key takeaway or skill you have learned from this course?',
    type: 'open-ended'
  },
  {
    id: 'learning_4',
    categoryId: 'learning',
    text: 'What is going well in this course and contributing to your learning?',
    type: 'open-ended'
  },
  {
    id: 'learning_5',
    categoryId: 'learning',
    text: 'What specific challenges have you faced in learning the material?',
    type: 'open-ended'
  },
  {
    id: 'learning_6',
    categoryId: 'learning',
    text: 'What is one specific change that could make this class more engaging or effective?',
    type: 'open-ended'
  }
];